const SET_MODAL = 'SET_MODAL';

export { SET_MODAL };
